import {gql} from "@apollo/client";

export const GET_JOB_STEP_RUNS = gql`
	query JobRun (
		$jobRunId: Int!
	) {
	    jobRun(where: {id: {eq: $jobRunId}}) {
	        nodes {
	            id,
	            start,
	            job {
	                id,
	                description,
	                jobDefinition {
	                    jobSteps {
	                        id
	                        description
	                        order
	                    }
	                }
	            }
	            graphQlQuery
	            jobStepRuns {
	                id
	                user
	                start
	                finish
	                total
	                failed
	                succeeded
	                cancel
	                jobStep {
	                    id,
	                    order
	                }
	            }
	        }
	    }
	}
`;
